// extracted by mini-css-extract-plugin
export default {"wrap":"c3ytb","benefit":"yfVVa","text":"HRq6E","icon":"Jo7As","isPulledDown":"BGRRK"};